import { cn } from './cn'

export type ControlVariant = 'outline' | 'soft'
export type ControlSize = 'sm' | 'md'
export function controlClassName(
  variant: ControlVariant,
  className?: string,
  size: ControlSize = 'md',
) {
  return cn(
    'w-full min-w-0 rounded-control border px-3.5 text-sm font-normal text-foreground outline-none transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/25 disabled:cursor-not-allowed disabled:opacity-60 [&:is(input,textarea):read-only]:bg-muted/50 aria-invalid:border-danger-foreground aria-invalid:focus-visible:ring-danger-foreground/25',
    variant === 'soft' ? 'border-transparent bg-control' : 'border-border bg-card',
    size === 'sm' ? 'h-9' : 'h-11',
    className,
  )
}
